/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');
var Radio = require('backbone.radio');
var FileUploadCollection = require('psa-backbone/models/FileUploadCollection');

var modelGet = require('common/util/modelGet');
var parsleyUtil = require('common/util/parsleyUtil');
var toggleForm = require('common/util/toggleForm');
var downloadDocument = require('common/util/downloadDocument');
var FileUploadView = require('common/views/FileUploadView');

require('../../styles/DepFilingPrintView.css');
var tmplDepBankAcquisitionMergerNewSubmissionSectionView = require('./DepBankAcquisitionMergerNewSubmissionSectionView.hbs');
var SubmitBankAcquisitionMergerNewFiling = require('../../services/SubmitBankAcquisitionMergerNewFiling');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepBankAcquisitionMergerNewSubmissionSectionView,

  className: 'dep-bank-acquistion-merger-new-submission-section-view',

  ui: {
    validationErrors: '.validation-errors',
    validationErrorSections: '.validation-error-sections',
    submissionForm: '.submission-form',
    missingFile: '.missing-file',
    supportingDocumentsContainer: '.supporting-documents-container',
    submit: '.submit',
    externalsubmissiontype: 'select[name="submissionTypeId"]',
    submissionInstructionsContainer: '.submission-instructions-container',
    submissionInstructionsTextContainer: '.submission-instructions-text-container',
    selectedFilingInstructions: '.selected-filing-instructions',
    downloadSubmissionInstructions: '.download-submission-instructions'
  },

  regions: {
    supportingDocumentsContainer: '@ui.supportingDocumentsContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit',
    'click @ui.downloadSubmissionInstructions': 'onClickDownloadSubmissionInstructions'
  },

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  templateHelpers: function() {
    var isReadOnly = this.options.isReadOnly;
    var isInternalFiling = this.options.mode === 'int-new';

    return {
      isReadOnly: isReadOnly,
      isInternalFiling: isInternalFiling,
      mode: this.options.mode
    };
  },

  onBeforeShow: function() {
    var filingDetails = this.model.get('filingDetails');
    var hasInstructionDocument = false;
    if (filingDetails && filingDetails.instructionsDocument && filingDetails.instructionsDocument.fileId) {
      hasInstructionDocument = true;
    }
    this.handleInstructionDisplay(hasInstructionDocument);

    var supportingDocuments = _.pluck(modelGet(this.model, 'filingContent.supportingDocuments', []), 'file');

    Syphon.deserialize(this, this.model.get('filingContent'));

    this.fileUploadView = new FileUploadView({
      isReadOnly: this.options.isReadOnly,
      allowMultipleFiles: true,
      isRequired: true,
      collection: new FileUploadCollection(supportingDocuments),
      metadata: {
        documentTypeId: 20001
      }
    });
    this.showChildView('supportingDocumentsContainer', this.fileUploadView);
  },

  onAttach: function() {
    if (this.options.mode === 'print') {
      this.switchToPrint();
    }
  },

  switchToPrint: function() {
    var textAreas = $('.input-view');

    _.each(textAreas, function(textArea) {
      var textAreaVal = textArea.value;
      var textAreaName = textArea.name;
      var printElementId = '#'.concat(textAreaName, 'PrintView');
      $(printElementId).text(textAreaVal);
    });
    toggleForm(textAreas, false);
  },

  handleInstructionDisplay: function(hasInstructionDocument) {
    toggleForm(this.ui.submissionInstructionsContainer, hasInstructionDocument);
  },

  onClickDownloadSubmissionInstructions: function(e) {
    e.preventDefault();
    var filingDetails = this.model.get('filingDetails');
    if (filingDetails && filingDetails.instructionsDocument && filingDetails.instructionsDocument.fileId) {
      downloadDocument({
        fileId: filingDetails.instructionsDocument.fileId,
        fileName: filingDetails.instructionsDocument.docName,
        isStatic: true
      });
    }
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.ui.validationErrors.hide();

    var l = Ladda.create(this.ui.submit[0]);

    this.sideNavView
      .validateAll({ type: 'submit' })
      .done(function() {
        l.start();

        var formData = self.sideNavView.getFormData();
        formData.filingId = self.model.get('filingId');

        SubmitBankAcquisitionMergerNewFiling(formData)
          .done(function() {
            Radio.channel('dp:draft-filing').trigger('proceed-to-payment', l);
            Radio.channel('dp:draft-filing').trigger('submit', l);
            Radio.channel('dp:submit-filing').trigger('resubmit', l);
          })
          .fail(function() {
            l.stop();
          });
      })
      .fail(function() {
        var errors = self.sideNavView.getSectionTitlesWithErrors();
        self.ui.validationErrorSections.empty();
        self.ui.validationErrorSections.append(errors.join('<br/>'));
        self.ui.validationErrors.show();
      });
  },

  validate: function(config) {
    this.ui.submissionForm.parsley().reset();
    this.ui.missingFile.hide();

    if (config.type === 'save') {
      // Turn off required field validation for this form
      parsleyUtil.disableRequiredValidation(this.ui.submissionForm);
    } else {
      // Turn on required field validation for this form
      parsleyUtil.enableRequiredValidation(this.ui.submissionForm);

      var validationPromises = [this.ui.submissionForm.parsley().whenValidate(), this.fileUploadView.validate()];
    }

    return $.when.apply($, validationPromises);
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.supportingDocuments = this.fileUploadView.collection.map(function(file) {
      return {
        fileId: file.get('fileId'),
        documentTypeId: modelGet(file, 'metadata.documentTypeId')
      };
    });

    return formData;
  }
});
